import { DataValidationError } from "constants/DataValidationError";
import { IsNotEmpty, MaxLength } from "class-validator";
import Spec from "constants/Spec";

export default class UpdateCastCategoryReq {
  @IsNotEmpty({ message: DataValidationError.DATA_IS_EMPTY })
  castCategoryId!: number;

  @MaxLength(Spec.maxLength.castCategory.name, {
    message: DataValidationError.DATA_IS_TOO_LONG,
    context: {
      constraint1: Spec.maxLength.castCategory.name,
    },
  })
  @IsNotEmpty({ message: DataValidationError.DATA_IS_EMPTY })
  name!: string;

  constructor(arg: any) {
    arg = arg || {};
    this.castCategoryId = arg.castCategoryId;
    this.name = arg.name;
  }
}
